import { render, staticRenderFns } from "./DiscountText.vue?vue&type=template&id=181c19d2"
import script from "./DiscountText.vue?vue&type=script&lang=js"
export * from "./DiscountText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports